<template>
  <v-container fluid>
    <alert-error :error="error" />

    <v-toolbar>
      <v-toolbar-title>{{ $t('EREPORTER.INVOICES.ITEMS') }}</v-toolbar-title>
    </v-toolbar>

    <v-sheet class="mt-5 pa-5" tile>
      <invoices-list-filter @setRequest="setRequest" />

      <invoices-list
        v-model="selectedInvoices"
        :invoices="invoices"
        :options.sync="options"
        :meta="meta"
        show-select
        @show="show"
      />

      <invoices-list-options
        :selected="selectedInvoices"
        :invoices="invoices"
        :filters="filters"
        @changeShowSelect="changeShowSelect"
      />
    </v-sheet>
  </v-container>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import InvoicesList from '../../components/Invoices/InvoicesList';
import InvoicesListFilter from '../../components/forms/Invoices/InvoicesListFilter';
import InvoicesListOptions from '@/modules/ereporter/components/Invoices/InvoicesListOptions';
import DataOptions from '@/modules/_global/classes/DataOptions';

export default {
  name: 'InvoicesPage',

  components: {
    InvoicesListOptions,
    InvoicesList,
    InvoicesListFilter,
    AlertError: () => import('@/modules/_global/_components/AlertError')
  },

  data() {
    return {
      error: null,
      meta: {
        total: 0
      },
      selectedInvoices: [],
      filters: {},
      options: {
        page: 1,
        itemsPerPage: 100,
        sortBy: ['id'],
        sortDesc: [true],
        groupBy: [],
        groupDesc: [],
        mustSort: false,
        multiSort: false
      },
      showSelectedOnly: false
    };
  },

  computed: {
    ...mapState('ereporter', ['invoices']),

    preparedOptions() {
      return DataOptions.createFromObject(this.options).toBackendFormat();
    },

    params() {
      return Object.assign({}, this.filters, this.preparedOptions);
    },

    selectedIds() {
      const ids = this.selectedInvoices.map(i => i.id);
      return ids.length ? ids : [''];
    }
  },

  watch: {
    options: {
      deep: true,
      handler() {
        this.refreshData();
      }
    },
    selectedInvoices: {
      deep: true,
      handler() {
        this.changeSelected();
      }
    },
    filters: {
      deep: true,
      handler() {
        this.options.page = 1;
        this.refreshData();
      }
    }
  },

  methods: {
    ...mapActions('ereporter', ['getInvoices']),
    refreshData() {
      this.getDataInvoices();
    },
    getDataInvoices() {
      this.getInvoices({ params: this.params })
        .then(({ data }) => {
          this.meta = data.meta;
        })
        .catch(error => {
          this.error = error;
        });
    },

    show(item) {
      this.$router.push({
        name: 'ereporter.invoice.show',
        params: { id: item.id }
      });
    },

    changeSelected() {
      if (this.showSelectedOnly) {
        this.setRequest();
      }
    },

    changeShowSelect(v) {
      this.showSelectedOnly = v;
      this.setRequest();
    },

    setRequest(v = this.filters) {
      this.selectedInvoices = [];
      this.filters = {
        ...v,
        ids: this.showSelectedOnly ? this.selectedIds : []
      };
    }
  }
};
</script>
